import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import "../Slide/SlideDeleteValidator.scss";
import "../../css/Popup.scss";
 
const ConvertHtmlModel = ({
  show,
  onConfirm,
  title = "CONVERT TO HTML",
  confirmText = "OK, GOT IT",
}) => {
 
  return (
    <div className="convertToHTMLPromptParent">
      <Dialog
        open={show}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="deletePrompt convert-html"
        sx={{
          backdropFilter: "blur(2.4px)",
        }}
      >
        <DialogContent style={{overflowY: "initial", width: "412px", height:"205px"}}>
          <DialogContentText
            id="alert-dialog-description"
            className="discription"
          >
            <div className="popup-head">{title}</div>
            <div className="popup-separator"></div>
            <div className="popup-message"> PDF to HTML conversion is in progress. You will receive an email notification once it is complete. You can track the progress via the notification bell icon on the dashboard. </div>
            <div className="popup-message popup-message-2"> Clicking on “OK, GOT IT” will redirect you to the dashboard. </div>
          </DialogContentText>
        </DialogContent>
        <div className="popupFooter" style={{justifyContent:"end"}}>
          {/* <Button>{" "}</Button> */}
          <Button
            className="btn popupFooterActiveButton"
            type="button"
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};
 
export default ConvertHtmlModel;